import qs from 'qs';
import _ from '@/common/helpers';

export default {
    data() {
        return {
            gridExposedSettings: null,
        };
    },
    methods: {
        /**
         * Moved from computed section because it doesn't update on route change
         */
        getExposedSettings() {
            // cache exposed settings
            if (this.gridExposedSettings) {
                return this.gridExposedSettings;
            }
            if (!this.tabs) {
                return null;
            }
            const {id} = this.tabs;
            // in router we already have parsed object by vue
            const {search} = new URL(window.location);
            const {grid} = qs.parse(search.substr(1));
            if (grid && grid.id === id) {
                // saving some space in browser's url
                grid.selectedColumns = grid.columns;
                delete grid.columns;
                this.gridExposedSettings = grid;
            }
            this.removeGridSettingsFromRoute();
            return this.gridExposedSettings;
        },
        /**
         * Ability to manual set exposed settings to break cache
         */
        setExposedSettings(settings) {
            this.gridExposedSettings = settings;
        },
        /**
         * Create settings object with all required data
         */
        getSettingsToExpose() {
            const {id} = this.tabs;
            const {selectedColumns} = this.columns;
            const {
                label, filter, sortBy,
            } = this.activeTab;
            return {
                id,
                columns: selectedColumns,
                tab: {label, filter, sortBy},
            };
        },
        /**
         * Convert settings object to url
         */
        generateSettingsUrl() {
            const url = new URL(location);
            const qsQuery = qs.parse(url.search.substr(1));
            qsQuery.grid = this.getSettingsToExpose();
            url.search = unescape(qs.stringify(qsQuery));
            return url.href;
        },
        /**
         * Remove grid settings from browser's url
         */
        removeGridSettingsFromRoute() {
            const url = new URL(location);
            const {name} = this.$route;
            const qsQuery = qs.parse(url.search.substr(1));
            const routeQuery = {};
            delete qsQuery.grid;
            url.search = unescape(qs.stringify(qsQuery));
            url.searchParams.forEach((item, key) => {
                routeQuery[key] = item;
            });
            // remove query params from URL without affecting the history
            // TODO move this into a beforeEnter route guard
            this.$router.replace({name, query: routeQuery}).catch(() => {});
        },
        /**
         * Checks whether the tab settings exposed from query string would
         * modify the tab it is being compared to
         * @param {Object} exposedTab Tab data collected from the query string
         * @param {FilterTab} existingTab An existing tab in the grid
         */
        exposedWillMutateTab(exposedTab, existingTab) {
            const whitelist = ['label', 'filter', 'sortBy'];
            const exposedData = _.pick(exposedTab, whitelist);
            const existingData = _.pick(existingTab, whitelist);
            return !_.isEqual({...existingData, ...exposedData}, existingData);
        },
    },
};
